var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-container',{staticClass:"bv-example-row px-0"},[_c('b-row',{staticClass:"mx-0 px-1"},[_c('b-col',{staticClass:"px-0 text-right mt-2",class:{ 'mb-3': _vm.sideBarLeft, 'mb-1': !_vm.sideBarLeft },staticStyle:{"font-size":"1rem"},attrs:{"cols":"12"}},[_c('span',{staticClass:"my-0",attrs:{"id":"elecboard-update-time"}},[_vm._v("更新時間:")]),_vm._v(" "),_c('span',{staticClass:"my-0",attrs:{"for":"elecboard-update-time"}},[_vm._v(_vm._s(_vm.nowtime))])]),_vm._v(" "),_c('b-col',{staticClass:"px-0 pt-2",attrs:{"cols":"12"}},[_c('b-row',{staticClass:"mx-auto",style:({
            width: _vm.sideBarLeft ? '100%' : '100%',
            'min-width': '89rem'
          })},[_c('b-col',{ref:"range",staticClass:"pr-2 pl-2",staticStyle:{"background-color":"#f2f2f2"},attrs:{"cols":"12"}},[_c('div',{staticStyle:{"width":"100%","height":"calc(100vh - 120px)"}},[_c('b-row',{staticClass:"mx-0 mt-0 py-2 d-flex justify-content-around"},[_c('b-col',{staticClass:"m-2",staticStyle:{"background-color":"#ffffff","min-width":"50.7rem"},style:({
                    height: _vm.home_map.clientHeight + 'px',
                    'min-height': _vm.home_map.clientHeight + 'px'
                  }),attrs:{"cols":"12"}},[_c('div',{staticStyle:{"position":"absolute","left":"0","width":"100%","height":"100%","background-color":"#ffffff"}},[(_vm.sideBarSelect.processName == '全廠')?[_vm._l((_vm.eboard_device_factory_one),function(item,key){return _c('div',{key:key,staticClass:"p-0",staticStyle:{"position":"absolute","cursor":"pointer","text-align":"center"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 857) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1892) +
                            'px',
                          width:
                            item.style.width * (_vm.home_map.clientWidth / 1892) +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 857) +
                            'px',
                          'background-color': item.color
                        }),attrs:{"id":item.device_name}})}),_vm._v(" "),_vm._l((_vm.eboard_device_factory_two),function(item,key){return _c('div',{key:key,staticClass:"p-0",staticStyle:{"position":"absolute","cursor":"pointer","text-align":"center"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 857) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1892) +
                            'px',
                          width:
                            item.style.width * (_vm.home_map.clientWidth / 1892) +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 857) +
                            'px',
                          'background-color': item.color
                        }),attrs:{"id":item.device_name}})}),_vm._v(" "),_vm._l((_vm.eboard_package),function(item,key){return _c('div',{key:key,staticClass:"px-0 py-0",staticStyle:{"position":"absolute","cursor":"pointer","text-align":"center"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 857) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1892) +
                            'px',
                          width:
                            item.style.width * (_vm.home_map.clientWidth / 1892) +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 857) +
                            'px',
                          'background-color': item.color,
                          'line-height':
                            item.style.height *
                              (_vm.home_map.clientHeight / 857) +
                            'px'
                        }),attrs:{"id":item.device_name}})}),_vm._v(" "),_vm._l((_vm.eboard_container),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","border-radius":"2px","text-align":"left","padding-left":"5px","overflow":"visible"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 857) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1892) +
                            'px',
                          width:
                            (item.style.width *
                              (_vm.home_map.clientWidth / 1892) *
                              (item.status == 'S'
                                ? 100
                                : item.load_status.load_percent)) /
                              100 +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 857) +
                            'px',
                          'background-color': item.color
                        }),attrs:{"id":item.device_name}},[_c('div',{staticStyle:{"font-size":"1rem","text-align":"left"},style:({
                            width:
                              item.style.width *
                                (_vm.home_map.clientWidth / 1892) +
                              'px',
                            'line-height':
                              item.style.height *
                                (_vm.home_map.clientHeight / 857) +
                              'px'
                          })},[_vm._v("\n                          "+_vm._s(item.status == "S"
                              ? item.title + "-"
                              : item.title +
                                item.load_status.load_percent +
                                "%")+"\n                        ")])])})]:(_vm.sideBarSelect.processName == '一廠')?_vm._l((_vm.eboard_device_factory_one),function(item,key){return _c('div',{key:key,staticClass:"p-0",staticStyle:{"position":"absolute","cursor":"pointer","text-align":"center"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          'background-color': item.color
                        }),attrs:{"id":item.device_name}})}):(_vm.sideBarSelect.processName == '二廠')?[_vm._l((_vm.eboard_device_factory_two),function(item,key){return _c('div',{key:key,staticClass:"p-0",staticStyle:{"position":"absolute","cursor":"pointer","text-align":"center"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          'background-color': item.color
                        }),attrs:{"id":item.device_name}})}),_vm._v(" "),_vm._l((_vm.eboard_package),function(item,key){return _c('div',{key:key,staticClass:"px-0 py-0",staticStyle:{"position":"absolute","cursor":"pointer","text-align":"center"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          'background-color': item.color,
                          'line-height':
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name}})}),_vm._v(" "),_vm._l((_vm.eboard_container),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","border-radius":"2px","text-align":"left","padding-left":"5px","overflow":"visible"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            (item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) *
                              (item.status == 'S'
                                ? 100
                                : item.load_status.load_percent)) /
                              100 +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          'background-color': item.color
                        }),attrs:{"id":item.device_name}},[_c('div',{staticStyle:{"font-size":"1rem","text-align":"left"},style:({
                            width:
                              item.style_single.width *
                                (_vm.home_map.clientWidth / 1890) +
                              'px',
                            'line-height':
                              item.style_single.height *
                                (_vm.home_map.clientHeight / 854) +
                              'px'
                          })},[_vm._v("\n                          "+_vm._s(item.status == "S"
                              ? item.title + "-"
                              : item.title +
                                item.load_status.load_percent +
                                "%")+"\n                        ")])])})]:_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.homeMapSize),expression:"homeMapSize"}],staticStyle:{"position":"absolute","width":"100%","height":"calc(100vh - 150px)","left":"0"}},[_c('img',{ref:"home_map",staticStyle:{"width":"100%","height":"100%","left":"0px","objfit":"content"},attrs:{"src":_vm.sideBarSelect.processName == '全廠'
                          ? _vm.eboardFactory
                          : _vm.sideBarSelect.processName == '一廠'
                          ? _vm.eboardFactory1
                          : _vm.sideBarSelect.processName == '二廠'
                          ? _vm.eboardFactory2
                          : _vm.eboardFactory,"alt":""}})]),_vm._v(" "),_c('div',{staticStyle:{"left":"0","position":"absolute","width":"100%","height":"100%"}},[(_vm.sideBarSelect.processName == '全廠')?[_vm._l((_vm.eboard_device_factory_one),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style.width * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + '_factory_one'},on:{"click":function($event){return _vm.chang_page(
                            item.device_name,
                            item.process,
                            item.group
                          )}}},[(
                            item.device_name !== '' &&
                              ((item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000'))
                          )?_c('b-popover',{attrs:{"target":item.device_name + '_factory_one',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)}),_vm._v(" "),_vm._l((_vm.eboard_device_factory_two),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style.width * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + '_factory_two'},on:{"click":function($event){return _vm.chang_page(
                            item.device_name,
                            item.process,
                            item.group
                          )}}},[(
                            item.device_name !== '' &&
                              ((item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000'))
                          )?_c('b-popover',{attrs:{"target":item.device_name + '_factory_two',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)}),_vm._v(" "),_vm._l((_vm.eboard_package),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style.width * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + 'package_all'},on:{"click":function($event){_vm.chang_page(
                            JSON.stringify({
                              work_code: item.work_code,
                              product_line: item.line
                            }),
                            item.process,
                            item.group
                          )}}},[(
                            (item.shape == 'rect' &&
                              item.color == '#00ff00') ||
                              (item.shape == 'rect' &&
                                item.color == '#ffc100') ||
                              (item.shape == 'rect' &&
                                item.color == '#cccdfe') ||
                              (item.shape == 'rect' &&
                                item.color == '#09b0ff') ||
                              (item.shape == 'rect' &&
                                item.color == '#99f98c') ||
                              (item.shape == 'rect' &&
                                item.color == '#ff0000')
                          )?_c('b-popover',{attrs:{"target":item.device_name + 'package_all',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)}),_vm._v(" "),_vm._l((_vm.eboard_container),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style.top * (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style.left * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style.width * (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + 'container_all'},on:{"click":function($event){return _vm.chang_page(
                            item.device_name,
                            item.process,
                            item.group
                          )}}},[(
                            (item.shape == 'rect' &&
                              item.color == '#00ff00') ||
                              (item.shape == 'rect' &&
                                item.color == '#ffc100') ||
                              (item.shape == 'rect' &&
                                item.color == '#cccdfe') ||
                              (item.shape == 'rect' &&
                                item.color == '#09b0ff') ||
                              (item.shape == 'rect' &&
                                item.color == '#99f98c') ||
                              (item.shape == 'rect' &&
                                item.color == '#ff0000')
                          )?_c('b-popover',{attrs:{"target":item.device_name + 'container_all',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)})]:(_vm.sideBarSelect.processName == '一廠')?_vm._l((_vm.eboard_device_factory_one),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + '_factory_one_s'},on:{"click":function($event){return _vm.chang_page(
                            item.device_name,
                            item.process,
                            item.group
                          )}}},[(
                            item.device_name !== '' &&
                              ((item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000'))
                          )?_c('b-popover',{attrs:{"target":item.device_name + '_factory_one_s',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)}):(_vm.sideBarSelect.processName == '二廠')?[_vm._l((_vm.eboard_device_factory_two),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + '_factory_two_s'},on:{"click":function($event){return _vm.chang_page(
                            item.device_name,
                            item.process,
                            item.group
                          )}}},[(
                            item.device_name !== '' &&
                              ((item.shape == 'rect' &&
                                item.color == '#00ff00') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ffc100') ||
                                (item.shape == 'rect' &&
                                  item.color == '#cccdfe') ||
                                (item.shape == 'rect' &&
                                  item.color == '#09b0ff') ||
                                (item.shape == 'rect' &&
                                  item.color == '#99f98c') ||
                                (item.shape == 'rect' &&
                                  item.color == '#ff0000'))
                          )?_c('b-popover',{attrs:{"target":item.device_name + '_factory_two_s',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)}),_vm._v(" "),_vm._l((_vm.eboard_package),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + '_package_s'},on:{"click":function($event){_vm.chang_page(
                            JSON.stringify({
                              work_code: item.work_code,
                              product_line: item.line
                            }),
                            item.process,
                            item.group
                          )}}},[(
                            (item.shape == 'rect' &&
                              item.color == '#00ff00') ||
                              (item.shape == 'rect' &&
                                item.color == '#ffc100') ||
                              (item.shape == 'rect' &&
                                item.color == '#cccdfe') ||
                              (item.shape == 'rect' &&
                                item.color == '#09b0ff') ||
                              (item.shape == 'rect' &&
                                item.color == '#99f98c') ||
                              (item.shape == 'rect' &&
                                item.color == '#ff0000')
                          )?_c('b-popover',{attrs:{"target":item.device_name + '_package_s',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)}),_vm._v(" "),_vm._l((_vm.eboard_container),function(item,key){return _c('div',{key:key,staticStyle:{"position":"absolute","cursor":"pointer","background-color":"transparent"},style:({
                          top:
                            item.style_single.top *
                              (_vm.home_map.clientHeight / 854) +
                            'px',
                          left:
                            item.style_single.left *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          width:
                            item.style_single.width *
                              (_vm.home_map.clientWidth / 1890) +
                            'px',
                          height:
                            item.style_single.height *
                              (_vm.home_map.clientHeight / 854) +
                            'px'
                        }),attrs:{"id":item.device_name + '_container_s'},on:{"click":function($event){return _vm.chang_page(
                            item.device_name,
                            item.process,
                            item.group
                          )}}},[(
                            (item.shape == 'rect' &&
                              item.color == '#00ff00') ||
                              (item.shape == 'rect' &&
                                item.color == '#ffc100') ||
                              (item.shape == 'rect' &&
                                item.color == '#cccdfe') ||
                              (item.shape == 'rect' &&
                                item.color == '#09b0ff') ||
                              (item.shape == 'rect' &&
                                item.color == '#99f98c') ||
                              (item.shape == 'rect' &&
                                item.color == '#ff0000')
                          )?_c('b-popover',{attrs:{"target":item.device_name + '_container_s',"triggers":"hover","placement":"top","custom-class":"elecboard-popover"}},[_vm._v("\n                          "+_vm._s(item.message)+"\n                        ")]):_vm._e()],1)})]:_vm._e()],2)])],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-795e5842","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 